import { Store } from "lucide-react";
import { PortalLoginForm } from "@/components/auth/PortalLoginForm";
import { ROUTES } from "@/constants/routes";

export default function StoreLogin() {
    return (
        <PortalLoginForm
            portal="store"
            title="Store Admin"
            subtitle="Manage your store — inventory, orders, staff."
            homePath={ROUTES.storeDashboard}
            accent="bg-emerald-600"
            icon={<Store className="h-5 w-5" />}
            testId="store-login-page"
        />
    );
}
